import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

const LLINKID_STATIC_PART: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  information: {
    definiteArticle: true,
    single: 'Statisch gedeelte',
    plural: 'Statisch gedeelte',
  },

  edit: [],
  buildingBlocks: [
    {
      type: NodeType.PARAGRAPH,
      max: 1,
    },
  ],
  showPlaceholder: true,
  readOnlyNode: true,
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default LLINKID_STATIC_PART;
